<template>
  <div class="add-another" @click="$emit('openSidebar')">
    <img src="@/assets/icons/ui/add-another-item.png" alt="add another item" />
  </div>
</template>

<script>
export default {
  name: "SidebarAddAnotherItem",
};
</script>

<style lang="scss">
.add-another {
  width: 48px;
  height: 48px;
  cursor: pointer;
}
</style>